import React from 'react'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import Button from '@uniiverse/library/components/button'
import { viewAllClicked } from './tracking'

import style from './index.css'

import locale from './locale'

const FindMoreEventsComponent = (props) => {
  const { formatMessage } = props.intl
  return (
    <div className={style.container}>
      <div className={style.title}>
        {formatMessage(locale.title)}
      </div>
      <div className={style.description}>
        {formatMessage(locale.description)}
      </div>
      <Link to="/explore" href="/explore">
        <Button onClick={() => (viewAllClicked(props))} type="primary">{formatMessage(locale.viewAll)}</Button>
      </Link>
    </div>
  )
}

export const FindMoreEvents = injectIntl(FindMoreEventsComponent)
